<template>
    <div class="content-body">
        <div class="left-list">
            <div class="left-list-title">
                <div class="color-block"></div>
                <div class="title">栏目</div>
                <div class="color-block end"></div>
            </div>
            <div class="left-list-content">
                <div class="block"></div>
                <div class="splitter"></div>
                <div class="list-content">
                    <div class="content">
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(1)">倡议书</a>
                        </p>
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(2)">图片1</a>
                        </p>
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(3)">图片2</a>
                        </p>
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(4)">图片3</a>
                        </p>
                        <p>
                            <a href="javascrip:void(0)" @click="openPage(5)">图片4</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <InitiativeView v-if="openIndex == 1"/>
        <PictureView :showImage="1" v-if="openIndex == 2"/>
        <PictureView :showImage="2" v-if="openIndex == 3"/>
        <PictureView :showImage="3" v-if="openIndex == 4" />
        <PictureView :showImage="4" v-if="openIndex == 5" />
    </div>
</template>

<script>
    import InitiativeView from "./InitiativeView";
    import PictureView from "./PictureView";
    export default {
        name: "PictureIndexView",
        components: {InitiativeView, PictureView},
        data() {
            return {
               openIndex: 1
            }
        },
        methods: {
            openPage: function (index) {
                this.openIndex = index
            }
        }
    }
</script>

<style lang="scss" src="../../assets/scss/menu.scss" scoped />